import React from 'react';

 const ArrowRight =  (props) => (
    <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
       <path d="M5.45703 0.8293L6.09297 0.222269C6.36224 -0.0347626 6.79766 -0.0347626 7.06406 0.222269L12.6328 5.53516C12.9021 5.79219 12.9021 6.20782 12.6328 6.46211L7.06406 11.7777C6.79479 12.0348 6.35937 12.0348 6.09297 11.7777L5.45703 11.1707C5.1849 10.9109 5.19062 10.4871 5.46849 10.2328L8.92031 7.09375H0.6875C0.30651 7.09375 0 6.80118 0 6.4375V5.5625C0 5.19883 0.30651 4.90625 0.6875 4.90625H8.92031L5.46849 1.76719C5.18776 1.51289 5.18203 1.08907 5.45703 0.8293Z" fill="#207B70"/>
    </svg>
);
export default ArrowRight